import React, { useEffect, useState } from 'react';
import Widget from '../../../components/Widget';
import DeviceIdelMovingTimeChart from '../../../components/Chart/DeviceIdelMovingTimeChart';
import PeriodSelector from './PeriodSelector';

function DeviceIdelMovingTime(props) {
    // const [chartTitle, setChartTitle] = useState('--');
    const [idleFuelRate, setIdleFuelRate] = useState(0);
    const [standardFuelRate, setStandardFuelRate] = useState(null);

    // useEffect(() => {
    //     console.log(props.loading);
    // }, [props.loading]);

    useEffect(() => {
        if (props.assetData) {
            // console.log(props.assetData.assetModel);
            const idleRate = props.assetData.assetModel && props.assetData.assetModel.idealFuelConsumptionRate || 0;
            const standardRate = props.assetData.assetModel && props.assetData.assetModel.standardFuelConsumptionRate || [];
            setIdleFuelRate(idleRate)
            setStandardFuelRate(standardRate)
            // setChartTitle(`Daywise Idle Time for Asset ${props.assetData.assetCode}`)
        }
    }, [props.assetData]);


    return (
        <Widget>
            {/* <PeriodSelector handleDataGroup={props.handleDataGroup} selectedGroup={props.selectedGroup} handlePeriodChange={props.handlePeriodChange}
                selectedValue={props.selectedValue} callFuelData={props.callFuelData} device={props.device} loading={props.loading} hasFuelSensor={props.hasFuelSensor} /> */}
            <DeviceIdelMovingTimeChart selectedGroup={props.selectedGroup} assetData={props.assetData} data={props.data} idleFuelRate={idleFuelRate} standardFuelRate={standardFuelRate}
                loading={props.loading} />
        </Widget>
    );
}

export default DeviceIdelMovingTime;
